import { render, staticRenderFns } from "./AddLogbook.vue?vue&type=template&id=2fd168fd&scoped=true&"
import script from "./AddLogbook.vue?vue&type=script&lang=js&"
export * from "./AddLogbook.vue?vue&type=script&lang=js&"
import style0 from "./AddLogbook.vue?vue&type=style&index=0&id=2fd168fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd168fd",
  null
  
)

export default component.exports